export default __webpack_public_path__ + "static/media/stader_partner.7e419374.png";